import { CloseOutlined, EditOutlined } from '@ant-design/icons';
import { Button, message, Modal, Table, Tag } from 'antd';
import { TagContainer, TagContent } from 'components/styles/tag';
import React, { useEffect, useState } from 'react';
import { clone } from 'lodash';
import { ContainerTable } from 'components/styles/table';
import ConfigProviderCustomize from 'components/ConfigProviderCustomize';
import { ColumnsType } from 'antd/lib/table';
import { onHeaderCell } from 'utils/tableUtils';
import ModelSelectTeacherPhong from './ModelSelectTeacherPhong';
import ModalSelectInitiatives from './ModalSelectInitiatives';
import { isAvailableArray } from 'utils/arrayUtils';
import { InitiativeAchievementHttp } from 'store/initiativeAchievement/services/initiativeAchievement.http';

const createReviewHttp = new InitiativeAchievementHttp();

interface ModelAssignReviewProps {
  open: boolean;
  school?: any;
  gradeId: any;
  yearIdSelect?: any;
  handleCancel: () => void;
}

function ModelAssignReview({
  open,
  school,
  gradeId,
  yearIdSelect,
  handleCancel
}: ModelAssignReviewProps) {
  const [isOpenListTeacher, setIsOpenListTeacher] = useState<boolean>(false);
  const [isOpenListAchievement, setIsOpenListAchievement] = useState<boolean>(false);
  const [valueTeacher, setValueTeacher] = useState<any>();
  const [valueListAchievement, setValueListAchievement] = useState<any[]>([]);
  const [teacherNumber, setTeacherNumber] = useState<number>();
  const [teacherInfo1, setTeacherInfo1] = useState<any>();
  const [teacherInfo2, setTeacherInfo2] = useState<any>();
  const [teacherData, setTeacherData] = useState<any>();
  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  const [schoolObj, setSchoolObj] = useState<any>();

  useEffect(() => {
    setSchoolObj(school);
  }, [school]);

  const handleOpenListTeacher = (teacherInfo, teacherNumber) => {
    const otherUser = teacherNumber === 1 ? teacherInfo2 : teacherInfo1;

    setIsOpenListTeacher(true);
    setTeacherNumber(teacherNumber);
    const data = [
      {
        user_id: teacherInfo?.user_id,
        other_user: clone(otherUser),
        userId_create: null,
        school_id: teacherInfo?.school_id
      }
    ];
    setValueTeacher(data);
  };

  const handleSuccess = (data) => {
    if (teacherNumber === 1) {
      setTeacherInfo1({
        name: `${data[0].teacher_fullname}`,
        user_id: data[0].user_id,
        school_id: data[0].school_id
      });
    } else {
      setTeacherInfo2({
        name: `${data[0].teacher_fullname}`,
        user_id: data[0].user_id,
        school_id: data[0].school_id
      });
    }
  };

  const handleOpenListAchievement = () => {
    const setTeacherInfo: any = [];
    if (teacherInfo1) {
      setTeacherInfo.push(teacherInfo1);
    }
    if (teacherInfo1) {
      setTeacherInfo.push(teacherInfo2);
    }
    setTeacherData(setTeacherInfo);
    setIsOpenListAchievement(true);
  };

  const handleSuccessListAchievement = (data) => {
    setValueListAchievement(data);
  };

  const handleSubmit = () => {
    if (!teacherInfo1 && !teacherInfo2) {
      message.warning('Vui lòng chọn giáo viên chấm sáng kiến');
      return;
    }
    if (!isAvailableArray(valueListAchievement)) {
      message.warning('Vui lòng chọn sáng kiến');
      return;
    }

    const data = {
      teacher_score_1: teacherInfo1?.user_id,
      teacher_score_2: teacherInfo2?.user_id,
      initiative_ids: valueListAchievement.map((item: any) => item.id),
      is_cv_permission: true
    };

    setIsSubmit(true);
    createReviewHttp.postRoleScore(data).then((res) => {
      if (res.ok && res.status === 200) {
        setIsSubmit(false);
        handleCancel();
        message.success('Phân quyền nhận xét sáng kiến thành công!');
      } else {
        setIsSubmit(false);
      }
    });
  };

  const columnsAchievement: ColumnsType<any> = [
    {
      title: 'STT',
      width: '4%',
      align: 'center',
      onHeaderCell,
      render: (text, record, index) => {
        return <span>{index + 1}</span>;
      }
    },
    {
      title: 'Mã công chức',
      dataIndex: 'ma_cong_chuc',
      key: 'ma_cong_chuc',
      width: '15%',
      align: 'center',
      onHeaderCell,
      render: (text) => {
        return <span style={{ color: '#1890ff' }}>{text}</span>;
      }
    },
    {
      title: 'Họ và tên',
      dataIndex: 'user_fullname',
      key: 'user_fullname',
      width: '13%',
      onHeaderCell,
      render: (text) => {
        return <span style={{ color: '#1890ff' }}>{text}</span>;
      }
    },
    {
      title: 'Tên sáng kiến',
      dataIndex: 'name',
      key: 'name',
      width: '18%',
      onHeaderCell,
      render: (text) => {
        return <span style={{ color: '#1890ff', cursor: 'pointer' }}>{text}</span>;
      }
    }
  ];

  return (
    <>
      <Modal
        visible={open}
        onCancel={() => handleCancel()}
        title={`Phân quyền nhận xét sáng kiến: ${schoolObj?.name}`}
        centered
        width={800}
        maskClosable={false}
        footer={[
          <Button key="back" size="large" onClick={handleCancel}>
            Đóng
          </Button>,
          <Button
            loading={isSubmit}
            key="submit"
            size="large"
            type="primary"
            onClick={handleSubmit}>
            Đồng ý
          </Button>
        ]}>
        <React.Fragment>
          <TagContainer>
            <Tag color={teacherInfo1 ? '#55acee' : undefined}>
              <TagContent>
                <span>{teacherInfo1?.name ? teacherInfo1?.name : 'Giám khảo 1'}</span>
                <EditOutlined onClick={() => handleOpenListTeacher(teacherInfo1, 1)} />
                {teacherInfo1 && <CloseOutlined onClick={() => setTeacherInfo1(null)} />}
              </TagContent>
            </Tag>

            <Tag color={teacherInfo2 ? '#55acee' : undefined}>
              <TagContent>
                <span>{teacherInfo2?.name ? teacherInfo2?.name : 'Giám khảo 2'}</span>
                <EditOutlined onClick={() => handleOpenListTeacher(teacherInfo2, 2)} />
                {teacherInfo2 && <CloseOutlined onClick={() => setTeacherInfo2(null)} />}
              </TagContent>
            </Tag>
          </TagContainer>
        </React.Fragment>
        <div style={{ marginTop: 10 }}>
          <Button onClick={handleOpenListAchievement} style={{ marginBottom: 10, marginTop: 10 }}>
            Chọn sáng kiến
          </Button>
          <ContainerTable>
            <ConfigProviderCustomize>
              <Table
                columns={columnsAchievement}
                dataSource={valueListAchievement}
                size="middle"
                bordered
                pagination={false}
                rowKey={(record: any) => record.keyUid}
              />
            </ConfigProviderCustomize>
          </ContainerTable>
        </div>
      </Modal>

      {isOpenListTeacher && (
        <ModelSelectTeacherPhong
          open={isOpenListTeacher}
          courseId={yearIdSelect}
          listTeacherChoose={valueTeacher}
          handleSuccess={handleSuccess}
          handleCancel={() => setIsOpenListTeacher(!isOpenListTeacher)}
        />
      )}

      {isOpenListAchievement && (
        <ModalSelectInitiatives
          open={isOpenListAchievement}
          listTeacherChoose={teacherData}
          listItemsChoose={valueListAchievement}
          gradeId={gradeId}
          courseId={yearIdSelect}
          schoolId={school.id}
          handleRefresh={() => {}}
          handleCancel={() => setIsOpenListAchievement(!isOpenListAchievement)}
          handleSuccess={handleSuccessListAchievement}
        />
      )}
    </>
  );
}

export default ModelAssignReview;
